export const EULA_VERSION = '2026-02-11';
export const EULA_EFFECTIVE_DATE_LABEL = 'February 11, 2026';
export const EULA_STORAGE_KEY = `seaus.firmwareUpdater.eula.accepted.${EULA_VERSION}`;

export type EulaAcceptanceRecord = {
  version: string;
  acceptedAt: string;
};

function getSafeStorage(fallback?: Storage | null): Storage | null {
  if (fallback !== undefined) {
    return fallback;
  }
  if (typeof window === 'undefined') {
    return null;
  }
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

export function readEulaAcceptance(storageOverride?: Storage | null): EulaAcceptanceRecord | null {
  const storage = getSafeStorage(storageOverride);
  if (!storage) {
    return null;
  }

  try {
    const raw = storage.getItem(EULA_STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw) as Partial<EulaAcceptanceRecord>;
    if (typeof parsed.version !== 'string' || typeof parsed.acceptedAt !== 'string') {
      return null;
    }
    return {
      version: parsed.version,
      acceptedAt: parsed.acceptedAt,
    };
  } catch {
    return null;
  }
}

export function hasAcceptedCurrentEula(storageOverride?: Storage | null): boolean {
  const accepted = readEulaAcceptance(storageOverride);
  return accepted?.version === EULA_VERSION;
}

export function persistEulaAcceptance(
  storageOverride?: Storage | null,
  acceptedAt: Date = new Date()
): boolean {
  const storage = getSafeStorage(storageOverride);
  if (!storage) {
    return false;
  }

  const record: EulaAcceptanceRecord = {
    version: EULA_VERSION,
    acceptedAt: acceptedAt.toISOString(),
  };

  try {
    storage.setItem(EULA_STORAGE_KEY, JSON.stringify(record));
    return true;
  } catch {
    return false;
  }
}
